import React from 'react'
import { Link } from 'react-router-dom'
import { FIGHTER_PATH } from '../App'
import { twMerge } from 'tailwind-merge'
import { weightClasses } from '../constants'

export default function EventFighterCard({ fighter, entry, className }) {
    const record = fighter.records[entry];
    return (
        <Link className={twMerge('w-full', className)} to={FIGHTER_PATH.replace(":id", fighter.id)}>
            <div className='w-full flex flex-row gap-4 md:h-[5rem] hover:translate-x-1 hover:bg-base-200 max-[980px]:flex-col' >
                <div className="flex flex-row gap-4 w-full">
                    <img className='aspect-square h-[5rem] object-center object-cover' src={fighter.fighterPicture} alt="" />
                    <div className='flex-center items-start w-full'>
                        <p className='font-bold text-xl'>{fighter.name ?? "???"}</p>
                        <p className='opacity-80'>
                            {
                                fighter.gender?.toUpperCase() === "M"
                                    ? "Male"
                                    : fighter.gender?.toUpperCase() === "F"
                                        ? "Female"
                                        : "??"
                            } · {
                                fighter.nationality ?? "?"
                            }
                        </p>
                        <p className='opacity-80'>{fighter.height ?? "?"} cm · {weightClasses[fighter.weightClass] ?? "???"}</p>
                    </div>
                </div>
                <div className='flex-center min-w-[5rem] max-[980px]:w-full max-[980px]:border border-base-200'>
                    <p className='font-bold opacity-80'>
                        {entry?.toUpperCase()}
                    </p>
                    <table className='w-full table'>
                        <thead>
                            <tr className='text-center'>
                                <th className='py-1'>W</th>
                                <th className='py-1'>L</th>
                                <th className='py-1'>D</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='text-center'>
                                <td className='py-1'>{record.win || "0"}</td>
                                <td className='py-1'>{record.loss || "0"}</td>
                                <td className='py-1'>{record.draw || "0"}</td>
                            </tr>
                        </tbody>
                    </table>
                    <p>
                    </p>
                </div>
            </div>
        </Link>
    )
}